module.exports = __webpack_public_path__ + "static/img/myOrder.6002f1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/myOrder.png
// module id = tTvZ
// module chunks = 1